import { render, staticRenderFns } from "./InterestShow.vue?vue&type=template&id=23e6f7ae&"
import script from "./InterestShow.vue?vue&type=script&lang=js&"
export * from "./InterestShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports